/*!
 * FT Locations
 * Developers: Financial Times (Czarnie Salazar, Ian O'Sullivan, Robert Pender and Steven Neiland)
 */
import { default as utils } from "../utils.min.js";

$(function () {
	if (typeof solutionChartData !== "undefined") {
		const dataConfig = {
			type: "doughnut",
			data: solutionChartData,
			options: {
				animation: {
					animateRotate: true,
				},
				rotation: Math.PI / 2, // Start at 9 o'clock (left)
				cutout: "55%",
				borderWidth: 0,
				plugins: {
					legend: {
						display: false,
					},
					tooltip: {
						enabled: false,
					},
				},
				events: [],
				onHover: (event) => {
					event.native.target.style.cursor = "default";
				},
				hover: {
					mode: null,
				},
			},
			plugins: [doughnutPath],
		};

		// CALL: utils.initChartJS(classSelector = "", chartClassName = "", chartData = {})
		utils.initChartJS(".solution-data", "data-chart", dataConfig);
	}

	// Pill ScrollTo
	$(".ft-fill-lists").on("click", "a.ft-btn-pill", function (e) {
		e.preventDefault();

		const $this = $(this);
		let navItem = $this.attr("href");
		navItem = navItem.replace("#", "");

		let scrollPosY = $(`#ft-${navItem}-scroll`).offset().top - 40;

		$("html, body").animate(
			{
				scrollTop: scrollPosY,
			},
			200,
		);
	});
});
